import React, { useRef, useState } from 'react'
import { Button, Col, Form, FormFeedback, Input, Label, Row } from 'reactstrap'
import Flatpickr from "react-flatpickr";
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import * as Yup from "yup"
import { useLocation, useNavigate } from 'react-router-dom';
import useApi from 'common/ApiMiddlewere';
import { dateFormat, formatDateToISO } from 'pages/Common';
import { routes } from 'routes/path';

const CountCreate = ({ data, isEdit }) => {
    const flatpickrRef = useRef(null);
    const navigate = useNavigate()
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const [countId, setCountId] = useState(0)
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [date, setDate] = useState(dateFormat(isEdit ? new Date(data?.Date) : new Date(), "dd-MM-yyyy"))

    const handleCancel = () => {
        navigate(routes.rentmakinglist, {
            state: {
                tab: "3",
            },
        })
    }

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            Count: isEdit ? data?.Count : "",
        },
        validationSchema: Yup.object({
            Count: Yup.string().required("The count is required"),
        }),
        onSubmit: values => {
            setformSumitLoading(true)
            if (values) {
                postApi("unbill/count/create-update", {
                    id: isEdit ? data?.Id : 0,
                    Date: formatDateToISO(date),
                    Count: String(values.Count),
                }).then(({ data, status }) => {
                    setformSumitLoading(false)
                    if (status == 400) {
                        toast.error(data, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    } else {
                        setDate(new Date())
                        handleCancel()
                        toast.success(isEdit ? "successfully updated" : "successfully created", {
                            style: {
                                fontSize: "15px",
                            },
                        })
                        validation.handleReset()
                    }
                })
            }
        },
    })

    return (
        <>
            <Form
                onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                }}
                onReset={e => {
                    e.preventDefault
                    validation.handleReset()
                    return false
                }}
            >
                <Row className='mt-3'>
                    <Col md={2} className="">
                        <div className="mb-2">
                            <Label
                                htmlFor="productDetailsValidationCustom01"
                                className="required"
                            >
                                Date
                            </Label>
                            <div className="d-flex date-after" >
                                <Flatpickr
                                    ref={flatpickrRef}
                                    className="form-control d-block flatpicker-date"
                                    placeholder="dd-MM-yyyy"
                                    value={date}
                                    onChange={(e) => setDate(e)}
                                    options={{
                                        dateFormat: "d-m-Y",
                                        disableMobile: true
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md="2" className="">
                        <div className="mb-2">
                            <Label
                                htmlFor="validationCustom03"
                                className="required"
                            >
                                Count
                            </Label>
                            <Input
                                name="Count"
                                placeholder="0"
                                type="text"
                                className="form-control-sm"
                                onKeyPress={handleKeyPress}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.Count || ""}
                                invalid={
                                    validation.touched.Count &&
                                        validation.errors.Count
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched.Count &&
                                validation.errors.Count ? (
                                <FormFeedback type="invalid">
                                    {validation.errors.Count}
                                </FormFeedback>
                            ) : null}
                        </div>
                    </Col>
                </Row>
                <div className="text-end mt-3">
                    <Button
                        task-title="secondary"
                        className="btn btn-primary me-2 btn-sm "
                        type="button"
                        color="secondary"
                        onClick={() => handleCancel()}
                    >
                        Cancel
                    </Button>
                    {formSumitLoading ? (
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                        >
                            <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                            Loading
                        </button>
                    ) : (
                        <Button
                            color="primary"
                            task-title="primary"
                            className="btn btn-primary btn-sm "
                            type="submit"
                        >
                            Submit
                        </Button>
                    )}
                </div>
            </Form>
        </>
    )
}

export default CountCreate